import { Base } from '@studiometa/js-toolkit';

/**
 * Checkbox component
 */
export default class Checkbox extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Checkbox',
    refs: ['input[]'],
    emits: ['changing'],
    options: {
      name: {
        type: String,
        default: '',
      },
    },
  };

  /**
   * mounted
   */
  mounted() {
    const params = Object.fromEntries(
      window.location.search
        .slice(1)
        .split('&')
        .map((p) => p.split('='))
        .map(([key, value]) => [decodeURIComponent(key), value])
    );

    Object.entries(params).forEach(([key, value]) => {
      console.log(key, this.$options.name);

      if (key === this.$options.name) {
        this.$refs.input.forEach((input) => {
          if (input.value === value) {
            input.setAttribute('checked', true);
          }
        });
      }
    });
  }

  /**
   * onInputChange
   */
  onInputChange() {
    this.$emit('changing', this.$options.name);
  }
}
